// src/utils/format.js — Formatting utility functions

/**
 * Format an ISO timestamp as a human-readable relative time string.
 */
export function formatTimeAgo(isoString) {
    if (!isoString) return '';
    const diff = Date.now() - new Date(isoString).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return mins + ' min ago';
    const hours = Math.floor(mins / 60);
    if (hours < 24) return hours + 'h ago';
    const days = Math.floor(hours / 24);
    return days + 'd ago';
}

/**
 * Zero-pad a number to 2 digits.
 */
export function pad(n) {
    return n.toString().padStart(2, '0');
}

/**
 * Format seconds as "M:SS" duration string.
 */
export function formatDuration(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.round(seconds % 60);
    return mins + ':' + secs.toString().padStart(2, '0');
}

/**
 * Monotonic clock accessor — uses performance.now() when available.
 */
export function monotonicNow() {
    return (typeof performance !== 'undefined' && typeof performance.now === 'function')
        ? performance.now()
        : Date.now();
}
